import {
    Button,
    Drawer,
    TableContainer,
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
} from "@material-ui/core";
import { PageRequest } from "api/sharedModels/PageRequest";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import { PopupNotification } from "components/PopupNotification/PopupNotification";
import ThorPagination from "components/ThorPagination/ThorPagination";
import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useStore } from "store/StoreConfigs";
import AddCustomerForm from "./AddCustomerForm";
import { userManagementStyles } from "./userManagementStyles";

export default observer(function CustomersTab() {
    const classes = userManagementStyles();
    const { customerStore, identityStore } = useStore();
    const [drawerOpen, setDrawerOpen] = useState(false);

    useEffect(() => {
        const request: PageRequest = {
            pageNumber: customerStore.currentPage,
            pageSize: 5,
            customerId: identityStore.currentCustomerId,
        };

        customerStore.loadCustomers(request);
    }, [customerStore.currentPage]);

    const closeDrawer = () => setDrawerOpen(false);
    const openDrawer = () => setDrawerOpen(true);

    const successCallback = (name: string) => {
        let id: string | number = "";

        const handlePopupClose = () => {
            toast.dismiss(id);
        };

        closeDrawer();

        id = toast(
            <PopupNotification
                type="success"
                title={`Customer '${name}' added successfully`}
                closeCallback={handlePopupClose}
            />
        );
    };

    if (customerStore.areCustomersLoading) {
        return (
            <div style={{ maxHeight: "300px", maxWidth: "300px" }}>
                <LoadingIndicator />
            </div>
        );
    }

    return (
        <div>
            <Button className={classes.addButton} onClick={openDrawer}>
                Add Customer
            </Button>

            {drawerOpen && (
                <>
                    <Drawer anchor="right" open={drawerOpen} onClose={closeDrawer}>
                        <AddCustomerForm successCallback={successCallback} />
                    </Drawer>
                </>
            )}
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Id</TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell>Address</TableCell>
                            <TableCell>Modules</TableCell>
                            <TableCell />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {customerStore.customers.map((customer) => (
                            <TableRow key={customer.id}>
                                <TableCell>{customer.id}</TableCell>
                                <TableCell>{customer.name}</TableCell>
                                <TableCell>{customer.email}</TableCell>
                                <TableCell>{customer.address}</TableCell>
                                <TableCell>{customer.modules.map((x) => x.name).join(", ")}</TableCell>
                                <TableCell>
                                    <Button>Edit</Button>
                                    <Button>Delete</Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <ThorPagination
                page={customerStore.currentPage}
                pages={customerStore.totalPages}
                onPageChange={customerStore.movePage}
                isLastPage={customerStore.isLastPage}
                setPage={customerStore.setPage}
            />
        </div>
    );
});
